module.exports = __webpack_public_path__ + "assets/img/btn.bd1f59ff.png";